const state = {
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
    stillWorkingTime: 10 * 60 * 1000 // 10 minutos
}

const getters = {
    user(state) {
        return state.user
    },
    stillWorkingTime(state){
        return state.stillWorkingTime
    }
}

const actions = {
    setUser({commit}){
        commit('USER', localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {})
    }
}

const mutations = {
    USER(state, user) {
        state.user = user
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
